import { PageHeader } from "@/components/common/ui-kit";
import { AssetsList } from "@/components/assets/AssetsList";

export default function AssetsPage() {
  return (
    <div data-testid="assets-page">
      <PageHeader overline="Asset & Contratti" title="Prodotti installati / Asset" description="Beni identificabili presso i clienti: seriali, sedi, proprietà, garanzie e storico. Le licenze sono gestite a parte." />
      <AssetsList />
    </div>
  );
}
